import { createVanIconComponent } from "./van"

const AddOutlined = createVanIconComponent("add-o")
export default AddOutlined
